<template>
  <headerView/>
  <router-view/>
  <footerview/>
</template>
<script setup>
import headerView from '@/components/headerView.vue'
import footerview from '@/components/footerview.vue'
</script>
<style>
.q-label{
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Limit to 2 lines */
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 2rem !important;
}
.ql-editor li:not(.ql-direction-rtl):before {
    margin-left: 0;
}
</style>
